import React from 'react';
import Field, {describedBy} from './Field';
import controls from './Controls.module.css';

const TextInput = React.forwardRef(({id, label, optional, helperText, error, mono, className = '', ...rest}, ref) => (
    <Field id={id} label={label} optional={optional} helperText={helperText} error={error}>
        <input
            ref={ref}
            id={id}
            className={`${controls.control} ${mono ? controls.mono : ''} ${className}`}
            aria-invalid={error ? 'true' : undefined}
            aria-describedby={describedBy(id, {helperText, error})}
            {...rest}
        />
    </Field>
));

export default TextInput;
